import { useEffect, useContext } from 'react';
import { AppContext } from '../window';
import Clarity from '@microsoft/clarity';

/**
 * Hook that identifies users in Microsoft Clarity based on:
 * - PHPSESSID for anonymous users
 * - au:_identity cookie value for logged in users
 */
export const useClarityIdentification = () => {
  const { user } = useContext(AppContext);

  useEffect(() => {
    if (!user?.id) return;
    let attempts = 0;
    const maxAttempts = 10;
    const tryIdentify = () => {
      // Prefer calling the global clarity function if available
      const w = (typeof window !== 'undefined' ? (window as any) : undefined);
      if (w && typeof w.clarity === 'function') {
        try {
          w.clarity('identify', `user:${user.id}`);
        } catch {}
        return;
      }
      // Fallback to package API if it exposes identify()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const pkg: any = Clarity as any;
      if (pkg && typeof pkg.identify === 'function') {
        try { pkg.identify(`user:${user.id}`); } catch {}
        return;
      }
      if (attempts++ < maxAttempts) {
        setTimeout(tryIdentify, 300);
      }
    };
    tryIdentify();
  }, [user?.id]);
};